import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import styled from "styled-components";

const Bar = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: ${({ theme }) => theme.gradient};
  transform-origin: 0%;
  z-index: 1200;

  @media (hover: hover) and (pointer: fine) {
    top: 0;
  }
`;

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 26,
    restDelta: 0.001,
  });
  return <Bar style={{ scaleX }} />;
};

export default ScrollProgress;
